export const DEFAULT_ERROR_MSG = 'Something went wrong';
export const PROGRAM_NOT_FOUND =
  'We are sorry, but the program you are looking for does not exist.';
